import Link from "next/link";
import { scrollToElement } from "@/utils/scrollToElement";

export const BLOCK_STORAGE_DATA = [
  { storage: "10 GB", price: "₹87" },
  { storage: "20 GB", price: "₹174" },
  { storage: "80 GB", price: "₹696" },
  { storage: "320 GB", price: "₹2,784" },
  { storage: "640 GB", price: "₹5,568" },
  { storage: "2560 GB", price: "₹22,272" },
  { storage: "5120 GB", price: "₹44,544" },
  { storage: "10240 GB", price: "₹89,088" },
];

export const TableFooterConstants = (
  <>
    We have a variety of storage options available for you to choose from to meet your
    needs. <br />
    At this time, All Block Storage services can be subscribed through special orders.
    <br />
    Please Contact{" "}
    <Link
      href="#contact-us"
      onClick={(e) => {
        e.preventDefault();
        scrollToElement("contact-us", 120);
      }}
      target="_blank"
      style={{ textDecoration: "underline", color: "#1E87F0", fontWeight: 700 }}
    >
      sales
    </Link>{" "}
    for more information and to get a deeper understanding of our services.
  </>
);
